// extracted by mini-css-extract-plugin
export default {"image":"File_image__U3jGL"};